import React, { useState } from "react";
import styles from "./CustomizedField.module.css";
import { TextField, Button, FormControlLabel, Checkbox } from "@mui/material";
import deleteImage from "./Images/delete.svg";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import CancelBtn from "../../../../../../../../components/Buttons/CancelBtn";
import SaveBtn from "../../../../../../../../components/Buttons/SaveBtn";
import EditIconBtn from "../../../../../../../../components/Buttons/EditIconBtn";
import DeleteBtn from "../../../../../../../../components/Buttons/DeleteBtn";
import DeletePopup from "../../../../../../../../components/CommonPopups/DeletePopup";

function CustomizedDbDropdownField(props: any) {
  const {
    field,
    onFieldChange,
    onDelete,
    isDropdownFieldFocused,
    setIsDropdownFieldFocused,
    leadsFromResponseChecked,
    edit = false,
    deleteAction = false,
    mandatory = false,
    // isNameUniqueCheck,
  } = props;

  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [question, setQuestion] = useState<string>("");
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
  const [answers, setAnswers] = useState<any[]>([]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleMandatoryChange = (e: any) => {
    const isMandatory = e.target.checked;
    onFieldChange({
      ...field,
      required: isMandatory,
    });
  };

  const handleQuestionChange = (e: any) => {
    setQuestion(e.target.value);
  };

  const generateId = (name: any) => {
    const withoutSpaces = name.replace(/\s+/g, "_").toLowerCase();
    return withoutSpaces;
  };

  const handleDeleteConfirmed = () => {
    setShowDeletePopup(false);
    onDelete(field);
  };

  const handleDeleteCancelled = () => {
    setShowDeletePopup(false);
  };

  const handleAddAnswer = () => {
    setAnswers([...answers, { answerId: "", answer: "", isValid: true }]);
  };

  // const handleAnswerChange = (index: number, value: string) => {
  //   setAnswers((prevAnswers) => {
  //     const newAnswers = [...prevAnswers];
  //     newAnswers[index].answer = value;
  //     return newAnswers;
  //   });
  // };

  const handleAnswerChange = (index: number, value: string) => {
    const updatedAnswers = answers.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          answer: value,
          answerId: value,
          isValid: true,
        };
      }
      return item;
    });

    const uniqueAnswers = new Set<string>();
    const finalAnswers = updatedAnswers.map((item) => {
      const isDuplicate = uniqueAnswers.has(item.answer.toLowerCase());
      uniqueAnswers.add(item.answer.toLowerCase());
      return { ...item, isValid: !isDuplicate || item.answer === "" };
    });

    setAnswers(finalAnswers);
  };

  const handleRemoveAnswerField = (index: number) => {
    setAnswers((prevAnswers) => prevAnswers.filter((_, i) => i !== index));
  };

  const capitalizeSentences = (text: string) => {
    let lowercasedText = text.toLowerCase();

    let capitalizedText = lowercasedText.replace(
      /(^\s*\w|[\.\!\?]\s*\w)/g,
      function (match) {
        return match.toUpperCase();
      }
    );

    return capitalizedText;
  };

  const hasEmptyAnswer = answers?.some((item) => item.answer === "");

  const handleCancelClick = () => {
    setIsEditing(false);
    setQuestion("");
  };
  const handleSaveClick = () => {
    const newOptions = answers?.map((answer) => ({
      name: answer.answer,
      id: answer?.answerId,
    }));

    onFieldChange({
      ...field,
      fieldName: question,
      options: newOptions,
    });

    setIsEditing(false);
  };

  React.useEffect(() => {
    setAnswers(
      field?.options?.map((d: any) => {
        return { answerId: d?.id, answer: d?.name, isValid: true };
      })
    );
    setQuestion(field?.fieldName);
  }, [field, isEditing]);

  return (
    <div className={styles.customizedFieldWrapper}>
      <div className={styles.customizedFieldTop}>
        <div className={styles.label}>
          {capitalizeSentences(field.fieldName)}
          {field.required === true && <span style={{ color: "red" }}>*</span>}
        </div>
        {!isEditing && (
          <div className={styles.customizedFieldTopRight}>
            {edit && <EditIconBtn onClick={handleEditClick} />}
            {deleteAction && (
              <DeleteBtn
                icon={deleteImage}
                onClick={() => setShowDeletePopup(!showDeletePopup)}
              />
            )}
            {showDeletePopup && (
              <DeletePopup
                open={showDeletePopup}
                onClose={handleDeleteCancelled}
                noBtnClick={handleDeleteCancelled}
                yesBtnClick={handleDeleteConfirmed}
                title={"Are you sure you want to delete this question?"}
              />
            )}
          </div>
        )}
      </div>

      <TextField
        placeholder="Write a question"
        disabled={!isEditing}
        fullWidth
        variant="outlined"
        size="small"
        value={isEditing ? question : ""}
        onChange={handleQuestionChange}
        inputProps={{
          style: {
            padding: "8px 12px",
            backgroundColor: isEditing ? "#FFFFFF" : "#FAFAFA",
            borderRadius: "4px",
          },
        }}
        draggable={isDropdownFieldFocused === false}
        onFocus={() => {
          setIsDropdownFieldFocused(true);
        }}
        onBlur={() => {
          setIsDropdownFieldFocused(false);
        }}
        // error={isEditing && !isNameUniqueCheck(question, field?.index)}
        // helperText={
        //   isEditing && !isNameUniqueCheck(question, field?.index)
        //     ? "Field label already exist"
        //     : ""
        // }
      />
      {!isEditing && mandatory && (
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              onChange={handleMandatoryChange}
              checked={field?.required}
              sx={{
                strokeWidth: 1,
                color: "#D0D5DD",
              }}
            />
          }
          label="Mandatory"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: "13px",
              color: "#667085",
              lineHeight: "20px",
            },
          }}
        />
      )}

      {isEditing ? (
        <div>
          <div
            style={{
              maxHeight: "250px",
              overflowY: "auto",
              marginTop: "20px",
              paddingRight: "5px",
            }}
          >
            {answers?.map((item, index) => (
              <TextField
                fullWidth
                key={`answer-${index}`}
                variant="outlined"
                size="small"
                value={item.answer}
                onChange={(e) => handleAnswerChange(index, e.target.value)}
                InputProps={{
                  endAdornment: (
                    <ClearIcon
                      fontSize="small"
                      style={{
                        cursor: "pointer",
                        color: "#667085",
                      }}
                      onClick={() => handleRemoveAnswerField(index)}
                    />
                  ),
                  style: {
                    backgroundColor: isEditing ? "#FFFFFF" : "#FAFAFA",
                    borderRadius: "4px",
                  },
                }}
                sx={{
                  "&.MuiTextField-root": {
                    marginTop: "12px",
                  },
                }}
                error={!item.isValid}
                helperText={!item.isValid ? "Answer already exist" : ""}
                disabled
              />
            ))}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <div className={styles.btnsWrap}>
              <CancelBtn onClick={handleCancelClick} />
              <SaveBtn
                onClick={handleSaveClick}
                disabled={
                  !question.trim() ||
                  // !isNameUniqueCheck(question, field?.index) ||
                  answers?.length === 0 ||
                  hasEmptyAnswer ||
                  answers?.filter((item: any) => item.isValid === false)
                    ?.length > 0
                }
              />
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default CustomizedDbDropdownField;
